import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Grid, Button, IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import { Menu as MenuIcon, Home as HomeIcon } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { useDevice } from 'components/DeviceContext.js';

const Navbar = () => {
    const location = useLocation();
    const isHome = location.pathname === '/';
    const { isMobile } = useDevice();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [showNavbar, setShowNavbar] = useState(true);

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    useEffect(() => {
        const controlNavbar = () => {
            if (window.scrollY < 80) {
                setShowNavbar(true);
            } else {
                setShowNavbar(false);
            }
        };

        window.addEventListener('scroll', controlNavbar);
        return () => {
            window.removeEventListener('scroll', controlNavbar);
        };
    }, []);

    return (
        <>
            {showNavbar && (
                <AppBar position="fixed" style={{ backgroundColor: isHome ? 'transparent' : 'transparent', padding: '1em', userSelect: 'none', boxShadow: 'none', top: 0, transition: 'top 0.3s' }}>
                    <Toolbar>
                        <Grid container alignItems="center" style={{ justifyContent: isMobile ? 'end' : 'center' }}>
                            {isMobile ? (
                                <>
                                    <IconButton component={Link} to="/" edge="start" color="inherit" aria-label="home">
                                        <HomeIcon />
                                    </IconButton>
                                    <IconButton edge="end" color="inherit" aria-label="menu" onClick={handleDrawerToggle}>
                                        <MenuIcon />
                                    </IconButton>
                                </>
                            ) : (
                                <Grid item>
                                    <IconButton component={Link} to="/" color="inherit" sx={{ marginRight: '15px' }}>
                                        <HomeIcon fontSize="medium" style={{ color: 'var(--branco)' }} />
                                    </IconButton>
                                    {/* <Button
                                        sx={{
                                            fontSize: '1.2em',
                                            marginRight: '20px',
                                            fontWeight: 'bold',
                                            color: 'var(--branco)'
                                        }}
                                        component={Link}
                                        to="/convocacao"
                                    >
                                        Convocação
                                    </Button> */}
                                    <Button
                                        sx={{
                                            fontSize: '1.2em',
                                            marginRight: '20px',
                                            fontWeight: 'bold',
                                            color: 'var(--branco)',
                                        }}
                                        component={Link}
                                        to="/programacao"
                                    >
                                        Programação
                                    </Button>
                                    <Button
                                        sx={{
                                            fontSize: '1.2em',
                                            marginRight: '20px',
                                            fontWeight: 'bold',
                                            color: 'var(--branco)',
                                        }}
                                        component={Link}
                                        to="/dicas"
                                    >
                                        Dicas e Serviços
                                    </Button>
                                    <Button
                                        sx={{
                                            fontSize: '1.2em',
                                            marginRight: '20px',
                                            fontWeight: 'bold',
                                            color: 'var(--branco)',
                                        }}
                                        component={Link}
                                        to="/noticias"
                                    >
                                        Notícias
                                    </Button>
                                    <Button
                                        sx={{
                                            fontSize: '1.2em',
                                            marginRight: '20px',
                                            fontWeight: 'bold',
                                            color: 'var(--branco)'
                                        }}
                                        target="_blank"
                                        component={Link}
                                        to="https://certificados.cnm.org.br/certificado/busca/163"
                                    >
                                        Certificados
                                    </Button>
                                    <Button
                                        sx={{
                                            fontSize: '1.2em',
                                            marginRight: '20px',
                                            fontWeight: 'bold',
                                            color: 'var(--branco)'
                                        }}
                                        target="_blank"
                                        component={Link}
                                        to="/Carta_SSA.pdf"
                                    >
                                        Carta de Salvador
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </Toolbar>
                </AppBar>
            )}

            <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
                <List>
                    <ListItem button component={Link} to="/" sx={{ color: 'var(--amarelo)' }}>
                        <ListItemText primary="Home" primaryTypographyProps={{ fontSize: '1.2em' }} />
                    </ListItem>
                    <ListItem button component={Link} to="/" sx={{ color: 'var(--amarelo)' }}>
                        <ListItemText primary="Convocação" primaryTypographyProps={{ fontSize: '1.2em' }} />
                    </ListItem>
                    <ListItem button component={Link} to="https://certificados.cnm.org.br/certificado/busca/163" sx={{ color: 'var(--amarelo)' }}>
                        <ListItemText primary="Certificados" primaryTypographyProps={{ fontSize: '1.2em' }} />
                    </ListItem>
                    <ListItem button component={Link} to="/programacao" sx={{ color: 'var(--amarelo)' }}>
                        <ListItemText primary="Programação" primaryTypographyProps={{ fontSize: '1.2em' }} />
                    </ListItem>
                    <ListItem button component={Link} to="/noticias" sx={{ color: 'var(--amarelo)' }}>
                        <ListItemText primary="Notícias" primaryTypographyProps={{ fontSize: '1.2em' }} />
                    </ListItem>
                </List>
            </Drawer>
        </>
    );
};

export default Navbar;
